export type ClientPlatform = 'h5' | 'pc'

const MOBILE_UA_RE = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile/i

function platformFromUa(ua: string): ClientPlatform {
  if (!ua) return 'h5'
  return MOBILE_UA_RE.test(ua) ? 'h5' : 'pc'
}

/** 当前设备：移动端 h5，桌面端 pc；无法判断时与后端一致默认 h5 */
export function resolveClientPlatform(): ClientPlatform {
  try {
    if (import.meta.client) {
      const nav = navigator as Navigator & { userAgentData?: { mobile?: boolean } }
      if (nav.userAgentData?.mobile === true) return 'h5'
      if (nav.platform === 'MacIntel' && nav.maxTouchPoints > 1) return 'h5'
      return platformFromUa(nav.userAgent || '')
    }
    return platformFromUa(useRequestHeaders(['user-agent'])['user-agent'] ?? '')
  } catch {
    return 'h5'
  }
}
